module.exports = __webpack_public_path__ + "img/PumpWithoutVFD.fbc91f0c.png";